<template>
  <div class="pb-2">
    <label v-if="label" :for="id" class="label-lg block py-1 px-2">
      <span>{{ label }}</span>
      <span v-if="required" class="text-error"> * </span>
    </label>
    <div class="relative">
      <span
        v-if="icon"
        :class="{
          'absolute left-0 pointer-events-none': true,
          'py-4 px-4': size == 'large',
          'py-3 pl-4 pr-3': size == 'normal',
        }"
      >
        <Icon
          :name="icon"
          :class="{
            'fill-[#9ca3af]': !isInputFocused && selected == '',
            'fill-on-surface/75': isInputFocused || selected != '',
            'fill-error': error,
          }"
        />
      </span>
      <span
        :class="{
          'absolute right-0 pointer-events-none': true,
          'p-4': size == 'large',
          'py-3 pr-4 pl-3': size == 'normal',
        }"
      >
        <!-- prettier-ignore -->
        <svg
          :class="{
            'fill-[#9ca3af]': !isInputFocused && selected == '',
            'fill-on-surface/75': isInputFocused || selected != '',
            'fill-error': error,
          }"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"
        >
          <path fill="inherit" d="m8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"/>
        </svg>
      </span>
      <select
        :id="id"
        ref="input"
        v-model="selected"
        v-bind="$attrs"
        :required="required"
        :class="{
          'bg-white label-large w-full block appearance-none pr-14': true,
          'rounded-full': rounded,
          'rounded-lg': !rounded,
          'h-14 py-4 px-6': size == 'large',
          'h-12 p-3 pl-4': size == 'normal',
          'border border-outline focus:outline-none focus:border-primary focus:ring focus:ring-primary-container active:outline-none': !elevated,
          'elevation-1 border border-transparent transition-shadow duration-300 hover:elevation-2 hover:transition-shadow hover:duration-300 focus:outline-none focus:border active:elevation-2 focus:elevation-2': elevated,
          'pl-14': icon, // Add padding if icon present
          'border-error': error,
          'text-[color:#9ca3af]': !isInputFocused && selected === '',
        }"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
        @input="handleInput"
      >
        <slot />
      </select>
    </div>
    <div v-if="error || hint" class="text-caption py-1 px-2 text-neutral40 opacity-80">
      <p v-if="error" class="text-error">{{ error.charAt(0).toUpperCase() + error.slice(1) }}</p>
      <p v-else-if="hint">{{ hint }}</p>
    </div>
  </div>
</template>

<script>
import Icon from '@/Components/Icon'

export default {
  name: 'FormSelect',
  inheritAttrs: false,
  components: { Icon },
  props: {
    id: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: String,
    value: [String, Number, Boolean],
    label: {
      type: String,
      default: '',
    },
    rounded: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'large'].includes(value),
    },
    elevated: {
      type: Boolean,
      default: false,
    },
    icon: String,
    icon_color: String,
    hint: String,
  },
  data() {
    return {
      selected: this.value,
      isInputFocused: false,
      isInputEmpty: true,
    }
  },
  watch: {
    value(value) {
      this.selected = value
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    handleInput(event) {
      this.isInputEmpty = event.target.value.length == 0
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style>
select > option {
  padding-inline: 0px;
  padding-block: 0px;
}
</style>
